/**
 * Desanitizes HTML entities back to their original characters
 * This reverses the sanitization done by sanitizeInput in the frontend
 * @param input - The sanitized string to desanitize
 * @returns Desanitized string with original characters restored
 */
export const desanitizeInput = (input: string | null | undefined): string => {
  if (!input || typeof input !== 'string') {
    return '';
  }

  return input
    .replace(/&#x2F;/g, '/')
    .replace(/&#x27;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&amp;/g, '&');
};


